import { Navigate, Route, Routes } from "react-router-dom";
import { useFeatures } from "@paralleldrive/react-feature-toggles";
import { FEATURE_NAME } from "@lib/features";
import { Account } from "./ui/Account";
import { Team } from "./ui/Team";
import { Plan } from "./ui/Plan";
import styles from "./settingsPage.module.scss";

export function SettingsPage() {
  const feat = useFeatures();
  const isTeamPageActivated = feat.includes(FEATURE_NAME.TEAM);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <Routes>
          <Route path="account" element={<Account />} />
          <Route path="plan" element={<Plan />} />
          {isTeamPageActivated && <Route path="team" element={<Team />} />}
          <Route path="*" element={<Navigate to="account" replace />} />
        </Routes>
      </div>
    </div>
  );
}
